<div class="mr-list">
  <div class="mr-list-item" *ngFor="let item of block.items">
    <mat-icon
      class="mr-list-icon"
      fontSet="material-icons-outlined"
      [attr.data-variant]="item.variant || null"
      >{{ item.icon || 'check' }}</mat-icon
    >
    <div class="mr-list-text" [innerHTML]="t(item.text) | markdownHtml"></div>
  </div>
</div>
